import { render, staticRenderFns } from "./pax_form.vue?vue&type=template&id=60724fc4&scoped=true&"
import script from "./pax_form.vue?vue&type=script&lang=js&"
export * from "./pax_form.vue?vue&type=script&lang=js&"
import style0 from "./pax_form.vue?vue&type=style&index=0&id=60724fc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60724fc4",
  null
  
)

export default component.exports